import * as React from 'react';
import { Field } from 'react-final-form';
import { RenderField } from 'forms';
import { isRequired } from 'forms/validators';
import { toNull } from 'forms/normalizers';

interface Props {
    name: string;
    label?: string;
    placeholder?: string;
}
export default function OrganizationNameInput(
    props: Props
): React.ReactElement {
    const { name, label, placeholder } = props;
    return (
        <Field
            name={name}
            component={RenderField as any}
            label={label}
            type="text"
            placeholder={placeholder}
            parse={toNull}
            validate={isRequired}
        />
    );
}

OrganizationNameInput.defaultProps = {
    label: 'Organization Name',
    placeholder: 'Please enter organization name'
};
